import { Timer } from "../Time/Timer";
import { AtlasUtils } from "./AtlasUtils";




export class AtlasAnimClipData {
    /**
     * Oznaceni animace
     */
    tag: number;
    /**
     * Atlas
     */
    atlas: pc.TextureAtlas;
    /**
     * Zaklad jmena snimku. K tomuto zakladu se prida index snimku
     */
    frameBaseName: string;
    /**
     * Doba zobrazeni jednoho snimku v ms
     */
    frameTimeLen: number;
    /**
     * Animacni sekvence s indexy jednotlivych snimku
     */
    sequence: number[];
    /**
     * Pocet zopakovani (undefined nebo 0 = clip se prehraje jen 1x, < 0, klip se bude prehravat do nekonecna)
     */
    loopCnt: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(atlas: pc.TextureAtlas, frameBaseName: string, fps: number, firstFrameId: number | number[], lastFrameId?: number, loopCnt: number = 0) {
        this.atlas = atlas;
        this.frameBaseName = frameBaseName;
        this.frameTimeLen = 1000 / fps;
        this.loopCnt = loopCnt;

        if (Array.isArray(firstFrameId)) {
            this.sequence = firstFrameId;
        }
        else {
            let seq: number[] = [];

            for (let i = firstFrameId; i <= lastFrameId; i++)
                seq.push(i);

            this.sequence = seq;
        }
    }
}



export class AtlasAnimClip extends pc.EventHandler {
    /**
     * Udalost vyvolana po dokonceni prehravani klipu
     * Parametry:
     * this
     */
    static readonly EVENT_COMPLETE = "complete";
    /**
     * Casovac pouzity pro animaci
     */
    private _timer: Timer;
    /**
     * (RO) Data animace
     */
    get data(): AtlasAnimClipData { return this._data; }
    private _data: AtlasAnimClipData;
    /**
     * Cas spusteni animace
     */
    private _startTime: number;
    /**
     * Aktualni pozice v animacni sekvenci
     */
    private _curSequencePos: number;
    /**
     * Index aktualniho snimku
     */
    private _curFrameId: number;
    /**
     * (RO) Rect v texture atlasu pro aktualni snimek
     */
    get curFrameRect(): pc.Vec4 { return this._curFrameRect; }
    private _curFrameRect: pc.Vec4;
    /**
     * (RO) Velikosti snimku v pixelech
     */
    get framePixSize(): pc.Vec2 { return this._framePixSize; }
    private _framePixSize: pc.Vec2;
    /**
     * (RO) True, pokud se klip prehrava
     */
    get isPlaying(): boolean { return this._startTime >= 0; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(timer: Timer) {
        super();

        this._timer = timer;
        this._startTime = -1;
        this._curFrameRect = new pc.Vec4();
        this._framePixSize = new pc.Vec2();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._startTime = -1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    play(data: AtlasAnimClipData): void {
        this._data = data;
        this._startTime = this._timer.time;
        this._curSequencePos = 0;
        this.setCurFrame(data.sequence[0]);

        // Velikost snimku v pixelech
        let frame = data.atlas.frames[data.frameBaseName + 0] as pc.TextureAtlasFrame;

        this._framePixSize.x = frame.rect.z;
        this._framePixSize.y = frame.rect.w;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    stop(): void {
        if (this._startTime >= 0) {
            this._startTime = -1;
            this.fire(AtlasAnimClip.EVENT_COMPLETE, this);
        }
    }

    //-------------------------------------------------------------------------
    /**
     * @returns True, pokud doslo ke zmene snimku
     */
    //-------------------------------------------------------------------------
    update(): boolean {
        if (this._startTime < 0)
            return false;

        // Vypocitat pozici v animacni sekvenci
        let seqPos = Math.floor((this._timer.time - this._startTime) / this._data.frameTimeLen);

        if (seqPos == this._curSequencePos)
            return false;

        this._curSequencePos = seqPos;

        // Ziskat index snimku na nove pozici v animacni sekvenci
        let frameId: number;

        if (seqPos < this._data.sequence.length) {
            frameId = this._data.sequence[seqPos];
        }
        else {
            let loopCnt = this._data.loopCnt;

            if (loopCnt == undefined || loopCnt == 0) {
                // Zastavit animaci
                this.stop();
                return true;
            }
            else {
                if (loopCnt < 0 || loopCnt >= Math.floor(seqPos / this._data.sequence.length)) {
                    frameId = this._data.sequence[seqPos % this._data.sequence.length];
                }
                else {
                    this.stop();
                    return true;
                }
            }
        }

        if (frameId != this._curFrameId) {
            this.setCurFrame(frameId);
            return true;
        }

        return false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private setCurFrame(frameId: number): void {
        this._curFrameId = frameId;
        AtlasUtils.getAtlasFrameRegion(this._data.atlas, this._data.frameBaseName + frameId, this._curFrameRect);
    }
}